module.exports = __webpack_public_path__ + "static/media/kswans-com-bg.df4d2621.jpg";